
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyAvatar as SkyAvatarElement } from '@sky.ui/core/sky-avatar';
 
 
 
 

 
 export const SkyAvatar = createComponent({
   displayName: 'SkyAvatar',
   react: React,
   tagName: 'sky-avatar',
   elementClass: SkyAvatarElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-avatar';
